import { Link, Outlet, createRootRoute } from "@tanstack/react-router";
import { useAppUpdate } from "../hooks/use-app-update";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const { refreshApp, isRefreshing } = useAppUpdate();

  return (
    <div className="min-h-[100svh] bg-neutral-50 text-neutral-900">
      <header
        className="sticky top-0 z-10 bg-white/80 backdrop-blur border-b border-neutral-200"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <div
          className="mx-auto max-w-5xl flex items-center justify-between gap-4 px-4 py-3 landscape:py-1.5"
          style={{
            paddingLeft: "max(1rem, env(safe-area-inset-left))",
            paddingRight: "max(1rem, env(safe-area-inset-right))",
          }}
        >
          <Link
            to="/"
            className="text-lg font-semibold tracking-tight landscape:text-base shrink-0"
          >
            lexivision
          </Link>
          <nav className="flex items-center gap-4 text-sm landscape:text-xs">
            <Link
              to="/dictation"
              className="text-neutral-600 hover:text-neutral-900"
              activeProps={{ className: "font-semibold text-neutral-900" }}
            >
              書き起こし
            </Link>
            <Link
              to="/objects"
              className="text-neutral-600 hover:text-neutral-900"
              activeProps={{ className: "font-semibold text-neutral-900" }}
            >
              ものの名前
            </Link>
            <Link
              to="/grammar"
              className="text-neutral-600 hover:text-neutral-900"
              activeProps={{ className: "font-semibold text-neutral-900" }}
            >
              文法
            </Link>
            <Link
              to="/review"
              className="text-neutral-600 hover:text-neutral-900"
              activeProps={{ className: "font-semibold text-neutral-900" }}
            >
              ふくしゅう
            </Link>
            <Link
              to="/settings"
              className="text-neutral-600 hover:text-neutral-900"
              activeProps={{ className: "font-semibold text-neutral-900" }}
              aria-label="設定"
            >
              ⚙️
            </Link>
            <button
              type="button"
              onClick={refreshApp}
              disabled={isRefreshing}
              className="text-neutral-600 hover:text-neutral-900 disabled:opacity-50"
              aria-label="アプリを更新"
              title="アプリを更新"
            >
              🔄
            </button>
          </nav>
        </div>
      </header>
      <main
        className="mx-auto max-w-5xl px-4 py-6 landscape:py-3"
        style={{
          paddingLeft: "max(1rem, env(safe-area-inset-left))",
          paddingRight: "max(1rem, env(safe-area-inset-right))",
          paddingBottom: "max(1.5rem, env(safe-area-inset-bottom))",
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}
